import { render, staticRenderFns } from "./unit-chart.vue?vue&type=template&id=b4f8307e&"
import script from "./unit-chart.vue?vue&type=script&lang=js&"
export * from "./unit-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports